export default 'M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24M9.44 8.06a1.5 1.5 0 1 1 2.12-2.12l5 5a1.5 1.5 0 0 1 0 2.12l-5 5a1.5 1.5 0 0 1-2.12-2.12L13.38 12z';